import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ProcessLine from '@/modules/workflow/components/List/ProcessLine.vue'
import * as types from '@workflow/store/types';
import * as dateutil from '@/util/date-helper'
import { mapActions, mapGetters, mapMutations } from 'vuex';
import api from '@workflow/api'
import * as accountTypes from '@account/store/types'

@Component({
    components: {
        ProcessLine
    },
    computed: {
        ...mapGetters({
            User: accountTypes.USER
        })
    },
    methods: {
        ...mapActions({
            setCurrent : types.WORKFLOW_CURRENT
        }),

        ...mapMutations({

        })
    }
})
export default class WorkflowListItem extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    open: boolean = false;
    openDrafter: boolean = false;
    drafterInfo: any = null
    approvalLineList: any[] | null = null

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) item!: workflow.WorkflowItem;
    @Prop({ type: Boolean, default: true }) showDetail!: boolean;

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setCurrent!: (data: any) => Promise<any>;

    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    /**
     * 결재현황보기 버튼 클릭시 호출
     */
    openApprovalView() {
        var data: any = {
            apmId: this.item.apmId, // 문서번호
            isMobile: true
        }
        api.form.getForm(data).then(res => {
            this.setCurrent(res)
        })
        this.$router.push({
            path: `/workflow/approvalState`,
            query: { id: String(this.item.apmId) },
        });
        this.open = false;
    }

    /**
     * 기안자보기 버튼 클릭시 호출
     */
     openDrafterView(item: any) {
        if (!this.drafterInfo) {
            var reqPerson = item.approvalLineList.find((v: any) => {
                return v.sortNumber === 0;
            });
    
            api.common.getUserByPersonCode(reqPerson.approverCode).then((res: any) => {
                this.drafterInfo = res;
                this.$emit('showDrafterModal', this.drafterInfo)
                this.open = false;
            });
        } else {
            this.$emit('showDrafterModal', this.drafterInfo)
            this.open = false;
        }
    }

    getDate(dateStr: string, format: string) {
        return dateutil.uGetDateFormat(format, dateutil.IEDate(dateStr));
    }

    /**
     * 목록에서 문서를 클릭하면 호출됩니다.
     * @param item 전자결재 문서 객체
     */
    select(item: any) {
        var data: any = {
            applicationId: this.item.applicationId,
            apmId: this.item.apmId, // 문서번호
            personCode: this.User.personCode,
            isEdit: false,
            isMobile: true
        }
       
        this.setCurrent(data).then(res => {

            let url: string = ``;
            let storekey = `s_${Date.now()}`;
            if (item.apmId) 
            {
                url = `/workflow/read?apmid=${item.apmId}&storekey=${storekey}`;        
            } 

            this.$router.push({
                path: url
            });

        })

    }
}
